// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1ZPD_","alertIcon":"ConfirmModal_alertIcon__24dfr"};